<template>
    <section class="content-terms">
        <div class="container">
            <div class="content-terms-link">
                <button tag="a" @click="hasHistory()
                    ? $router.go(-1)
                    : $router.push('/')" class="btn-return">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69" height="69" viewBox="0 0 69 69">
                        <defs>
                            <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                            <stop offset="0" stop-color="#fece09"/>
                            <stop offset="1" stop-color="#f5891f"/>
                            </linearGradient>
                            <filter id="Ellipse_2" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse">
                            <feOffset dy="6" input="SourceAlpha"/>
                            <feGaussianBlur stdDeviation="6" result="blur"/>
                            <feFlood flood-opacity="0.161"/>
                            <feComposite operator="in" in2="blur"/>
                            <feComposite in="SourceGraphic"/>
                            </filter>
                        </defs>
                        <g id="Group_2353" data-name="Group 2353" transform="translate(-18 -43)">
                            <g transform="matrix(1, 0, 0, 1, 18, 43)" filter="url(#Ellipse_2)">
                            <circle id="Ellipse_2-2" data-name="Ellipse 2" cx="16.5" cy="16.5" r="16.5" transform="translate(18 12)" fill="url(#linear-gradient)"/>
                            </g>
                            <path id="Union_1" data-name="Union 1" d="M11.562,0h.723V12.285h-.723V.723H0V0Z" transform="translate(55.187 79.873) rotate(-135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                        </g>
                    </svg>
                    <h3>{{ contentTerms.name }}</h3>
                </button>
            </div>
            <div class="content-terms-text" v-html="contentTerms.text">
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            contentTerms: {}
        }
    },
    methods: {
        hasHistory() {
            return window.history.length > 1;
        },
    },
    async mounted() {
        axios.post('/api/v1/legal-information', this.$route.params).then(resp => { 
            this.contentTerms = { ...resp.data }
        }).catch( error => {
            console.log(error);
        })
    },
}
</script>

<style lang="scss">
.content-terms {
    margin-top: 210px;
    @media (max-width: 991px){
        margin-top: 170px;
    }
    &-link {
        button {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background: 0;
            border: 0;
            margin-left: -25px;
        }
    }
    &-text {
        padding: 50px 0px 100px 0px;
        text-align: left;
        p {
            font-size: 18px;
            font-family: 'Font Regular';
            color: #202620;
        }
    }
}
</style>
